module.exports = __webpack_public_path__ + "assets/img/label-classify-6.344a56ff.png";